module.exports = __webpack_public_path__ + "fullScreen.cd8fb6c5.png";